import { isNil, isString } from 'lodash'

// 定义默认颜色选项的类型
interface ColorOptions {
  keyColor: string
  numberColor: string
  stringColor: string
  trueColor: string
  falseColor: string
  nullColor: string
}

// 默认颜色选项
const defaultColors: ColorOptions = {
  keyColor: 'dimgray',
  numberColor: 'lightskyblue',
  stringColor: 'lightcoral',
  trueColor: 'lightseagreen',
  falseColor: '#f66578',
  nullColor: 'cornflowerblue'
}

// HTML 实体映射
const entityMap: { [key: string]: string } = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#x60;',
  '=': '&#x3D;'
}

// 转义 HTML 字符的函数
function escapeHtml(html: string): string {
  return String(html).replace(/[&<>"'`=]/g, s => {
    return entityMap[s]
  })
}

// 主函数，格式化并高亮 JSON
export const jsonFormatHighlight = (
  json: any,
  colorOptions: Partial<ColorOptions> = {}
) => {
  if (isNil(json)) {
    return ''
  }
  if (!isString(json)) {
    json = JSON.stringify(json, null, 2)
  }
  const colors: ColorOptions = { ...defaultColors, ...colorOptions }
  json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>')
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+]?\d+)?)/g,
    match => {
      let color = colors.numberColor
      let style = ''
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          color = colors.keyColor
        } else {
          color = colors.stringColor
          match = `"${escapeHtml(match.substr(1, match.length - 2))}"`
          style = 'word-wrap:break-word;white-space:pre-wrap;'
        }
      } else {
        color = /true/.test(match)
          ? colors.trueColor
          : /false/.test(match)
            ? colors.falseColor
            : /null/.test(match)
              ? colors.nullColor
              : color
      }
      return `<span style="${style}color:${color}">${match}</span>`
    }
  )
}
